import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPrice',
    standalone: false
})

export class FormatPricePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value === '-1,00') {
      value = 'N/A';
    } else if(value === '0,00') {
      value = 'FREE';
    } else {
      value = value + '€';
    }
    return value;
  }

}